export default __webpack_public_path__ + "static/digital-transform-01b3934e3eb0b47fbc553636e40983f9.png";